import clsx from 'clsx'
import { DetailedHTMLProps, FC, forwardRef, InputHTMLAttributes } from 'react'
import s from './Input.module.scss'
export type InputProps = {
  className?: string
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

const Input: FC<InputProps> = forwardRef(({ className, ...props }, ref) => {
  return <input className={clsx(s.root, className)} ref={ref} {...props} />
})

Input.displayName = 'Input'
export default Input
